<script lang="ts">
	//Svelte hooks
	import { beforeUpdate } from 'svelte';
	//Services
	import { postReq } from '../../../services/http';
	import { format } from '../../../services/i18n';
	//Stores
		import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import {
		ControlsContainer,
		DeviceButton,
		DeviceButtonV2,
		Text,
		toast,
	} from '@Shelly/shelly-design-system';
	import { real_id } from 'src/helpers/interface_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device;

	$: statusStore = getDeviceStatus(device.id);
	$: status = $statusStore;

	let isMuted = false,
		hasAlarm;

	const muteAlarm = async () => {
		const res = await postReq(`/device/sensor/gas_sensor_mute`, {
			id: device.id,
			mute: isMuted ? 0 : 1,
		});

		if (res.isok) {
			toast.open({
				type: 'info',
				title: isMuted
					? $format('mute_scc_toast', { default: 'Muted' })
					: $format('unmute_scc_toast', { default: 'Unmuted' }),
			});
			isMuted = !isMuted;
		} else {
			isMuted = false;
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};
	beforeUpdate(() => {
		hasAlarm = status?.gas_sensor?.alarm_state !== 'none'; //Smoke is detected
		if (!hasAlarm && isMuted) {
			//doing this because device didn't sent anything to indicate that alarm is muted
			isMuted = false;
		}
	});
</script>

<ControlsContainer class="mb-s" color="color-0">
	<svelte:fragment slot="first">
		{#if $showNewLayout}
			<DeviceButtonV2
				id="devicebutton-tsxxsvg"
				variant="primary"
				size={'l'}
				icon={'fa fa-volume-mute'}
				aria-label={$format('label_mute', { default: 'Mute' })}
				isActive={isMuted}
				disabled={!hasAlarm}
				on:click={muteAlarm}
			/>
		{:else}
			<DeviceButton
				id="devicebutton-tsxxsvg"
				variant="primary"
				size={'l'}
				icon={'fa fa-volume-mute'}
				aria-label={$format('label_mute', { default: 'Mute' })}
				isActive={isMuted}
				disabled={!hasAlarm}
				on:click={muteAlarm}
			/>
		{/if}

		<Text class="text-bold mt-s-plus">{$format('label_mute', { default: 'Mute' })}</Text>
	</svelte:fragment>
</ControlsContainer>
